<template>
  <div class="hitwrapper utbildning">
    <div class="hittitle">
      <a :href="hit.url">
        {{ hit.title }},
        {{ hit.credits }}
        <Icon type="arrow-right" />
      </a>
    </div>
    <div class="kortfakta">
      <span class="fakta"
        ><Icon :type="'fa-calendar'" />{{ texts.startdatum }} {{ hit.valkomstinfostartdatum }}</span
      >
    </div>
  </div>
</template>
<script>
import Icon from "../../../image/icon.vue";
export default {
  name: "ValkomstInfoItem",
  props: {
    hit: Object,
    texts: Object,
  },
  components: {
    Icon,
  },
  methods: {
  },
};
</script>
